import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useCurrentUser } from '../../contexts/CurrentUser';
import { CustomDashboard } from '../../components/CustomDashboard/CustomDashboard';
import { ampli } from '../../ampli';

export const DashboardDetailPage: React.FC = () => {
  const { dashboardId } = useParams<{ dashboardId: string }>();
  const [currentUser] = useCurrentUser();
  const isSuperAdmin = currentUser?.is_super_admin ?? false;
  const trackedDashboardRef = useRef<string | null>(null);

  useEffect(() => {
    if (!dashboardId || !currentUser?.id || trackedDashboardRef.current === dashboardId) {
      return;
    }
    trackedDashboardRef.current = dashboardId;
    ampli.track({
      event_type: 'Open custom dashboard',
      event_properties: {
        user_id: currentUser.id,
        workspace_id: currentUser.workspace_id,
        dashboard_id: dashboardId,
        is_super_admin: isSuperAdmin,
      }
    });
  }, [dashboardId, currentUser?.id, currentUser?.workspace_id, isSuperAdmin]);

  if (!dashboardId) {
    return null;
  }

  return (
    <CustomDashboard dashboardId={dashboardId} isAdmin={isSuperAdmin} />
  );
};
